import styles from "./components.module.scss";
import {CrossButtonBlack} from "components/Buttons/CrossButton";
import clsx from "clsx";
import React from "react";
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles";

export const CannotCallModal = ({ firstName, onCloseButtonClick}: { firstName: string, onCloseButtonClick: (e: any) => void }) => {
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>Cannot Call</div>
                <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                  onClick={onCloseButtonClick}/>
            </div>
            <div className={styles.description}>
                You’ll have access to {firstName}'s phone number within 2h of the start of the shift. But don’t worry - if you need to contact them, you can send them a direct message by clicking <b>Messages</b>
            </div>
            <StyledButton
                variant="outlined"
                size="large"
                onClick={onCloseButtonClick}
                className={clsx(styles.okButton)}
            >
                OK
            </StyledButton>
        </>
    );
}

export const ModifyShiftModal = ({firstName, onSubmit, onCloseButtonClick}: { firstName: string, onSubmit: (e: any) => void, onCloseButtonClick: (e: any) => void }) => {
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>READ CAREFULLY</div>
                <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                  onClick={onCloseButtonClick}/>
            </div>
            <div className={styles.description}>
                Modifying the shift time of a booked shift is changing your agreement and commitment with {firstName}.
                <br/><br/>
                {firstName} will be notified about your shift change.
                <b> Changes to the original hours you booked may result in {firstName} having to cancel this shift.</b>
                <br/><br/>
                In the event {firstName} needs to cancel because of this change, we will notify you via email -
                so be sure to monitor your inbox.<br/><br/>
                Are you sure?
            </div>
            <StyledButton
                variant="outlined"
                size="large"
                onClick={onCloseButtonClick}
            >
                No
            </StyledButton>
            <StyledButton
                variant="contained"
                size="large"
                onClick={onSubmit}
            >
                Yes
            </StyledButton>
        </>
    );
}